import {
  AccountId,
  ApiResponse,
  ExternalAccount,
  FullExternalAccountRequest,
  PlaidCreateTokenLinkRequest,
  PlaidCreateTokenLinkResponse,
  PlaidLinkExternalAccountRequest,
  PlaidPublicTokenExchangeRequest,
  PlaidPublicTokenExchangeResponse,
} from '@arrived/models';

import { api } from './api';
import { unwrapApiResponse } from './utils';

export const getUserExternalAccount = async (accountId: AccountId) => {
  const response = await api.get<ApiResponse<ExternalAccount>>(`/users/accounts/${accountId}/external/bank`);

  return unwrapApiResponse(response.data);
};

export const postUserExternalAccount = async (request: FullExternalAccountRequest) => {
  const response = await api.post<ApiResponse<ExternalAccount>>(
    `/users/accounts/${request.accountId}/external/bank`,
    request
  );

  return unwrapApiResponse(response.data);
};

export const deleteUserExternalAccount = async (accountId: AccountId) => {
  const response = await api.delete<ApiResponse<void>>(`/users/accounts/${accountId}/external/bank`);

  return unwrapApiResponse(response.data);
};

export const postLinkPlaidExternalAccount = async (request: PlaidLinkExternalAccountRequest) => {
  const response = await api.post<ApiResponse<ExternalAccount>>(
    `/users/accounts/${request.accountId}/external/bank/link/plaid`,
    request
  );

  return unwrapApiResponse(response.data);
};

export const postPlaidCreateTokenLink = async (request: PlaidCreateTokenLinkRequest) => {
  const response = await api.post<ApiResponse<PlaidPublicTokenExchangeResponse>>('/plaid/link/token/create', request);

  return unwrapApiResponse(response.data);
};

export const getPlaidVerificationTokenLink = async (accountId: AccountId) => {
  const response = await api.get<ApiResponse<PlaidCreateTokenLinkResponse>>(
    `/users/accounts/${accountId}/external/bank/link/plaid/verify`
  );

  return unwrapApiResponse(response.data);
};

export const postPlaidVerifyExternalAccount = async (accountId: AccountId) => {
  const response = await api.post<ApiResponse<ExternalAccount>>(`/users/accounts/${accountId}/external/bank/verify`);

  return unwrapApiResponse(response.data);
};

export const getPlaidVerificationStatus = async (accountId: AccountId) => {
  const response = await api.get<ApiResponse<string>>(
    `/users/accounts/${accountId}/external/bank/link/plaid/verification`
  );

  return unwrapApiResponse(response.data);
};

export const postPlaidExchangePublicToken = async (request: PlaidPublicTokenExchangeRequest) => {
  const response = await api.post<ApiResponse<PlaidPublicTokenExchangeResponse>>(
    '/plaid/item/public_token/exchange',
    request
  );

  return unwrapApiResponse(response.data);
};
